import { Record, List } from 'immutable';


export const DepartmentInfoRecord = new Record({
  'classification': 1,
  'd_id': '',
  'name': '',
  'u_id': 0,
  'um_id': 0,
  'type': 2,
});

export const RoleInfoRecord = new Record({
  // 'role': '',
  'title': '',
  'u_id': 0,
  'ug_id': 0,
  'attr': new Record({
    'rwd': 0,
    'ug_id': 0,
    'um_id': 0,
    'u_id': 0,
    'type': 1
  })
});

const ItemRecord = new Record({
  'loading': false,
  'token': '',
  'u_id': 0,
  'dpm_id': 0,
  'g_id': 0,
  's_id': 0,
  'd_id': 0,
  'username': '',
  'real_name': '',
  'status': 0,
  'createtime': '',
  'mobile_phone': '',
  'sex': 0,
  'groups': '',
  'lan_ip': '',
  'wan_ip': '',
  'job_title': '',
  'roles_info': new List([new RoleInfoRecord()]),
  'department_info': new List([new DepartmentInfoRecord()]),
});

export const UsersRecord = new Record({
  'loading': false,
  'data': new List([new ItemRecord()]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});
